import { useEffect } from "react";

/**
 * Hook to detect Stripe checkout completion and notify the opener window
 *
 * When Stripe redirects back to Rapid with ?checkout=success:
 * 1. Sends a postMessage to the opener window to close the upgrade modal
 * 2. Automatically closes the current window after a brief delay
 *
 * This enables a seamless checkout flow where:
 * - User opens checkout in a new tab from the upgrade modal
 * - After completing payment, Stripe redirects back to Rapid
 * - The original tab's modal closes automatically
 * - The checkout tab closes itself
 */
export function useCheckoutCompletion() {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const isCheckoutComplete = urlParams.get("checkout") === "success";

        if (isCheckoutComplete && window.opener) {
            // Send message to the opener window to close the upgrade modal
            window.opener.postMessage({ type: "stripe-checkout-complete" }, window.location.origin);

            // Close this window after a brief delay to give user feedback
            setTimeout(() => {
                window.close();
            }, 500);
        }
    }, []);
}
